module.exports = __webpack_public_path__ + "img/crowdsourcing.22aeea4.png";